// --------------------------------------------------------------
// Created On: 2023-02-02
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./AssetgroupListRow.module.scss";

// A single asset group in an asset group list.
export default function AssetgroupListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="assetgroup-list-row">
      <span data-test="assetgroup-title">{props.name}</span>
      {props.isDefault && (
        <span data-test="default-assetgroup-marker" className={styles.tag}>
          Default
        </span>
      )}
    </div>
  );
}

interface Props {
  assetgroupId: number;
  name: string;
  isDefault: boolean;
}
